function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDF6A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "index-desktop-copy-7",
  transform: "translate(-796.000000, -565.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy",
  transform: "translate(796.000000, 565.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Watch_2218663",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.5913363,7.10542736e-15 L5.40865316,7.10542736e-15 C4.98121555,7.10542736e-15 4.63470891,0.338506162 4.63470891,0.756074673 L4.63470891,12.4965081 C1.71790591,14.7996773 0.0161029403,18.2622677 0.000110551718,21.9261117 C-0.015657592,25.5899557 1.65606895,29.0665007 4.55280239,31.3937175 L4.72163059,43.2542609 C4.72749651,43.6677547 5.07226759,44 5.49557484,44 L5.50653389,44 L19.6877001,43.803965 C20.1150059,43.798093 20.4565694,43.4549962 20.4506853,43.0375547 L20.2866091,31.5111963 C23.2505502,29.2110711 24.9844929,25.7201881 24.9998992,22.0223088 C25.0151012,18.3244294 23.3101095,14.8199636 20.3653038,12.4965005 L20.3653038,0.756074673 C20.3653038,0.555547272 20.2837603,0.363233283 20.1386126,0.221441125 C19.9934648,0.0796489671 19.7966031,7.10542736e-15 19.5913363,7.10542736e-15 Z M6.18259741,1.51214935 L18.8173921,1.51214935 L18.8173921,11.4562627 C14.9224558,9.19991285 10.0775336,9.19991285 6.18259741,11.4562627 L6.18259741,1.51214935 Z M18.892217,42.3025292 L6.25856004,42.4771824 L6.1160382,32.4543617 C9.99702221,34.7352371 14.8428481,34.7650737 18.7529535,32.5321693 L18.892217,42.3025292 Z M19.3240779,30.3291038 C19.1224935,30.3765437 18.9497174,30.502816 18.8462215,30.6783423 C15.2800389,33.2036496 10.5086352,33.3842804 6.753102,31.136151 C2.99756878,28.8880216 0.995924848,24.6529232 1.67993681,20.4022743 L12.2993265,23.1961139 C12.4312922,23.2305709 12.5702064,23.2305709 12.7021722,23.1961139 L23.3200527,20.4022743 C23.9305764,24.1744217 22.4012218,27.9736292 19.3240624,30.3290736 L19.3240779,30.3291038 Z M22.9917997,18.9222733 L12.5007687,21.6828834 L2.00824396,18.9222204 C3.38838398,14.3863655 7.65617689,11.2761399 12.5000159,11.2761399 C17.343855,11.2761399 21.6116338,14.3864049 22.9917997,18.9222657 L22.9917997,18.9222733 Z",
  id: "Shape",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 12.5,
  cy: 21.9249147,
  rx: 11.1111111,
  ry: 10.8122867
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  x: 11,
  y: 17,
  width: 2,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2129687,20.72207 C14.6876831,20.729162 15.0706947,21.1124717 15.0774175,21.5871914 L15.162803,27.6166238 C15.1692784,28.0738813 14.8038473,28.4498111 14.3465899,28.4562865 C14.3385591,28.4564002 14.330527,28.4563971 14.3224962,28.4562771 C13.8477819,28.4491851 13.4647702,28.0658754 13.4580475,27.5911556 L13.372662,21.5617232 C13.3661865,21.1044658 13.7316176,20.728536 14.188875,20.7220606 C14.1969059,20.7219469 14.2049379,20.72195 14.2129687,20.72207 Z",
  id: "Rectangle-Copy",
  fill: "#000000",
  transform: "translate(14.267732, 24.589174) rotate(-40.000000) translate(-14.267732, -24.589174) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  x: 25,
  y: 19,
  width: 2,
  height: 5,
  rx: 1
}))));
function SvgWatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "44px",
    viewBox: "0 0 27 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIcon);
export default __webpack_public_path__ + "static/media/watch-icon.62d3f1bb32324fc130edbcf74897c46e.svg";
export { ForwardRef as ReactComponent };